import { InvokeStatusType } from '@g2-shared/api-client/generated/risk-app';
import { LabelColor } from '@g2-shared/components';

export const UserInvokeStatusTypeMapper: Record<InvokeStatusType, string> = {
  [InvokeStatusType.APPROVED]: 'Approved',
  [InvokeStatusType.NEW]: 'New',
  [InvokeStatusType.REJECTED]: 'Rejected',
};

export const UserInvokeStatusTypeColorMapper: Record<InvokeStatusType, LabelColor> = {
  [InvokeStatusType.APPROVED]: 'success',
  [InvokeStatusType.NEW]: 'primary',
  [InvokeStatusType.REJECTED]: 'error',
};
